import React from "react";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
const ShortNewsGrid = () => {
  return (
    <Link
      aria-label={`Short News Banner`}
      href={"https://www.vikatan.com/short-news"}
      externalLink={"https://www.vikatan.com/short-news"}
      className={`hidden-desktop`}
    >
      <div className={styles["shortnews-wrapper"]}>
        <div className={styles["logo-div"]}>
          <img
            src="https://gumlet.assettype.com/vikatan/2021-10/3552b2f7-c1f9-46f9-b98b-c175fed866dc/vikatan_bytes.png"
            width="110px"
            height="40px"
          />
          <h4>ஷார்ப்பா... ஸ்வீட்டா...</h4>
        </div>
        <div className={styles["content"]}>
          <h6>
            இப்போ செய்திகளை <br />
            ஷார்ட்டா படிக்க...
          </h6>
          <p className={styles["link"]}>இங்க க்ளிக் பண்ணுங்க</p>
        </div>
      </div>
    </Link>
  );
};

export { ShortNewsGrid };
